import { gql } from "apollo-boost";

export const WarningAddressFragment = gql`
  fragment WarningAddressFragment on WarningAddress {
    id
    createdAt
    address1
    address2
    city
    country
    state
    postalCode
    company
  }
`;
